import React, { useCallback } from 'react';
import cx from 'classnames';
import maximizeIcon from '../../images/icons/maximize-icon.svg';
import './QuizImage.scss';

const QuizImage = React.memo(({ src, onToggleImage, expanded }) => {
  const imageClass = cx('image-container', {
    'expanded': expanded,
  });

  // useCallback ensures that handleKeyPress is not recreated on every render unless necessary
  const handleKeyPress = useCallback((event) => {
    if (event.key === 'Enter') {
      onToggleImage();
    }
  }, [onToggleImage]); // onToggleImage is a dependency of this callback

  return (
    <div
      className={imageClass}
      onClick={onToggleImage}
      tabIndex="0"
      role="button"
      aria-expanded={expanded}
      aria-label={expanded ? 'Collapse image' : 'Expand image'}
      onKeyDown={handleKeyPress}
      style={{ cursor: 'pointer' }}
    >
      {!expanded && (
        <img
          src={maximizeIcon}
          alt="Expand"
          className="expand-icon"
          aria-hidden="true"
        />
      )}
      <img
        className="quiz-image"
        src={src}
        alt="Quiz image content"
      />
    </div>
  );
});

export default QuizImage;